import { Component } from '@angular/core';
import { PrimaryNavComponent } from '../Components/Partials/primary-nav/primary-nav.component';
import { SecondaryNavComponent } from '../Components/Partials/secondary-nav/secondary-nav.component';

@Component({
  selector: 'app-navigation',
  imports: [PrimaryNavComponent, SecondaryNavComponent],
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss',
})
export class NavigationComponent {

}
